import React from 'react';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import {withStyles, Drawer, Icon, IconButton} from '@material-ui/core';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as Actions from './Store/Actions'
import withReducer from 'app/store/withReducer';
import reducer from './Store/Reducers';
import CatchErro from 'app/Core/Components/CatchErro/CatchErro';

const styles = theme => ({
    root: {
        width: "100%"
    }
});

class LinkPainel extends XAPPComponent {

    render()
    {
        const {classes, state, toggleLinkPainel, site} = this.props;

        var ASite = site;
        if (site !== undefined && site !== null && site.length > 0 && !site.includes('http'))
        {
            ASite = 'http://' + ASite;
        }

        return (
            <React.Fragment>
                <CatchErro
                    //url={this.props.match.url}
                >
                    <Drawer
                        classes={{paper: classes.root}}
                        open={state}
                        anchor="right"
                        onClose={toggleLinkPainel}
                    >
                        <React.Fragment>
                            <div className="flex">
                                <div className="flex-1"/>
                                <IconButton onClick={toggleLinkPainel} color="inherit">
                                    <Icon className="text-32">clear</Icon>
                                </IconButton>
                            </div>
                            <iframe
                                title="site"
                                src={ASite}
                                width="100%"
                                height="100%"
                            />
                        </React.Fragment>
                    </Drawer>
                </CatchErro>
            </React.Fragment>
        );

        
    }
}

function mapDispatchToProps(dispatch)
{
    return bindActionCreators({
        toggleLinkPainel : Actions.toggleLinkPainel,
    }, dispatch);
}

function mapStateToProps({LinkPainel})
{
    return {
        state: LinkPainel.state,
        site : LinkPainel.site,
    }
}

export default withReducer('LinkPainel', reducer)(withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(LinkPainel)));
